module.exports = __webpack_public_path__ + "static/media/2.9928d0ae.webm";